import i18next, { Resource } from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import { initReactI18next, getDefaults } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';

import TRANSLATION from '../../../constants/TRANSLATION';
import extranetLanguageDetector from './extranetLanguageDetector';

import getLanguageCode from '../../../utils/language/getLanguageCode';
import Translation from '../../../services/translation/Translation';
import { ConfigTranslationOptions } from './configTranslation';

export default function configureI18next(options: ConfigTranslationOptions = {}) {
  const lngDetector = new LngDetector();

  lngDetector.addDetector(extranetLanguageDetector);

  // The extranet cookie is usually specified on .iafg.net
  const mainDomain = window.location.hostname.split('.').slice(-2).join('.');

  const shoulduseSuspense = typeof getDefaults().useSuspense !== 'undefined';

  const reactOptions = {
    [shoulduseSuspense ? 'useSuspense' : 'wait']: false,
  };

  return i18next
    .use(lngDetector)
    .use(initReactI18next)
    .use(intervalPlural)
    .init({
      initImmediate: true,
      resources: Translation.getInitialTranslations().reduce((result, { language, namespace, messages: resource }) => {
        result[language] = result[language] || {};
        result[language][namespace] = result[language][namespace] || {};
        Object.assign(result[language][namespace], resource);
        return result;
      }, {} as Resource),
      detection: {
        order: ['cookie', 'extranet', 'navigator'],
        lookupCookie: 'language',
        caches: options.saveCookie ? ['cookie'] : [],
        cookieDomain: (mainDomain === 'localhost') ? mainDomain : `.${mainDomain}`,
        ...options.detection,
      },
      fallbackLng: process.env.REACT_APP_DEFAULT_LOCALE || 'en',
      debug: options.debug || false,
      ns: [TRANSLATION.APP_NAMESPACE],
      defaultNS: TRANSLATION.APP_NAMESPACE,
      interpolation: {
        ...options.interpolation,
      },
      react: reactOptions,
    }, () => {
      if (process.env.REACT_APP_MOCK_EXTRANET_CONTEXT === 'true') {
        window.EEContext.language = getLanguageCode(i18next.language);
      }
    });
}
